import { useNavigate, useParams, useLocation } from "react-router-dom";
import ReportCard from '../../../components/reportCard/ReportCard';
import Sidebar from '../../../components/sidebar/Sidebar';
import NavBar from '../../../components/navbar/NavBar';
import './reportlanding.css';

const CategoryLanding = () => {
  const navigate = useNavigate();
  const { url } = useParams();
  const location = useLocation();
  let data =  location.state;

  const categories = [
    ...new Map(
      data
        .filter(r => (r.PARENT_NAME || '').toLowerCase() === url)
        .map(obj => [obj.CATEGORY_NAME, obj])
    ).values()
  ];

  const handleClick = (category, data) => {
    navigate( `/reportslanding/${url}/${category.CATEGORY_NAME.toLowerCase()}`,
      { state: data }
    );
  };

  return (
    <div className='LandingPage'>
      <div className="LandingPageContainer">
        <NavBar/>
        <Sidebar/>
        <div className="trackingLandingpageContent">
          <div className="reportLandingTitle">
            <h1>Reports by Category</h1>
          </div>
          <div className="reportLandingReports">
            {categories.map(category =>
              <ReportCard
                key={category.CATEGORY_ID}
                title={category.CATEGORY_NAME}
                onClick={() => handleClick(category, data)}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CategoryLanding